import { Box, Typography } from '@mui/material';
import { useTranslate } from 'react-admin';

import { ExternalLink } from '@sh4res/bo-common/components';

import { TranslationKeys } from '@I18n/types';

const links = ['accessibility', 'legal_information', 'data_protection', 'cookie', 'sitemap'];

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: { xs: '16px 16px', md: '16px 32px' },
    gap: '8px',
    borderTop: '1px solid',
  },
  links: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '8px 24px',
    margin: 0,
    padding: 0,
  },
  link: {
    listStyleType: 'none',
  },
  bottom: {
    display: 'flex',
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '32px',
  },
  brand: {
    textAlign: { xs: 'center', md: 'right' },
  },
};

export const Footer = () => {
  const translate = useTranslate();

  return (
    <Box
      id="footer"
      sx={{ ...styles.root, borderColor: 'divider' }}
      component="footer"
      role="contentinfo">
      <Box sx={styles.bottom}>
        <Box sx={styles.links} component="ul">
          {links.map((link) => (
            <li style={styles.link} key={link}>
              <ExternalLink
                variant="subtitle2"
                sx={{ color: 'primary.main' }}
                href={translate(`footer.links_href.${link}` as TranslationKeys)}>
                {translate(`footer.links_label.${link}` as TranslationKeys)}
              </ExternalLink>
            </li>
          ))}
        </Box>
        <Typography variant="caption" color="text.secondary" sx={styles.brand}>
          {translate('footer.brand', { year: new Date().getFullYear() })}
        </Typography>
      </Box>
    </Box>
  );
};
